'use client';

import { useState, useMemo } from 'react'
import Image from '@src/components/atoms/safe-image';
import { useParams } from 'next/navigation';

// Components
import Modal from "@src/components/modal";
import Button from "@src/components/century-21-or-company/button";

// Context
import useGlobalCtx from '@src/context/global-ctx';

// Hooks
import useOnChangeNumber from '@src/hooks/useOnChangeNumber';
import useSlack from '@src/hooks/useSlack';

// Assets
import InfoIcon from "@public/png/info-2.png"
import XIcon from '@public/png/x-1.png';

// Actions
import { postJoin } from '@src/apis/shared/post-join';

const CInput = ({ label, ...props }) => {
  return (
    <div className="mb-6 last:mb-6">
      <p className='mb-[6px] text-15 text-grey-1'>{label}<span className='text-red-2'>*</span></p>
      <input
        {...props}
        className='bg-white-3 text-15 w-full text-black-1 py-[6px] px-4 border border-solid border-grey-0  rounded-[180px] placeholder:text-grey-6'
      />
    </div>
  )
}

const FormJoin = ({ onClose, onSuccess, ...props }) => {
  const { companySlug } = useParams();

  const { setShowLoader } = useGlobalCtx()
  const { sendMessage } = useSlack()

  const onChangeNumber = useOnChangeNumber();

  const [form, setForm] = useState({
    full_name: "",
    phone: "",
    address: "",
  });

  const isValid = useMemo(() => {
    if (!form.full_name || !form.phone || !form.address) return false;

    return true
  }, [form])

  const onChangeForm = (e) => {
    const newValue = e.target.value;
    const name = e.target.name;

    let newForm = { ...form };
    newForm[name] = newValue

    setForm(newForm);
  }

  const handleSubmitContact = async () => {
    try {
      setShowLoader(true)
      const payload = {
        marketing_applicant: {
          ...form
        }
      }

      const slackPayload = {
        ...form,
        page: window.location.href
      }

      await postJoin(payload, companySlug)
      await sendMessage(slackPayload)

      setForm({
        name: "",
        phone: "",
        property_location: ""
      })
      setShowLoader(false)
      onSuccess()
    } catch (error) {
      console.log(error)
      setShowLoader(false)
    }
  }
  
  return (
    <Modal {...props}>
      <div className='px-2 py-4 overflow-y-auto bg-white-3 z-[42] rounded-2xl w-[460px] 
      dd-xl:w-[364px] dd-xl:px-2 dd-xl:py-4
      dd-lg:h-full dd-lg:w-full dd-lg:rounded-[unset]'>
        <div className='px-4'>
          <div className='flex justify-end'>
            <Image onClick={onClose} src={XIcon} alt='Close' width="auto" height="auto" className='w-4 h-4 cursor-pointer object-contain' />
          </div>
          <p className='text-22 font-sfpro-bold'>Gabung Bersama Kami</p>
          <p className='text-12 text-grey-1 mb-4'>Silahkan isi formulir di bawah ini.</p>
        </div>

        <div className='p-4 rounded-2xl border-[0.5px] border-solid border-grey-0'>
          <CInput onChange={onChangeForm} name="full_name" label="Nama Lengkap" placeholder="contoh: Samsul Arifin" />
          <CInput onChange={(e) => onChangeNumber(e, form, setForm)} name="phone" label="Nomor WhatsApp" placeholder="contoh: 082167890980" />
          <CInput onChange={onChangeForm} name="address" label="Domisili" placeholder="contoh: Setiabudi" />

          <div className='flex items-start'>
            <Image
              src={InfoIcon}
              alt='Info'
              width="auto"
              height="auto"
              className='w-4 h-4 object-contain mr-[6px]'
            />
            <p className='text-11 text-grey-1'>Ini akan membantu kami untuk mengarahkan pengajuan Anda kepada kantor CENTURY 21 terdekat dengan domisili yang dimasukkan.</p>
          </div>
        </div>

        <div className='px-4 flex justify-end mt-4 
        dd-xl:justify-center'>
          <Button disabled={!isValid} onClick={handleSubmitContact} icon={InfoIcon} text="KIRIM" />
        </div>
      </div>
    </Modal>
  )
}

const Wrapper = ({ isOpen, ...props }) => {
  if (!isOpen) return null;
  return <FormJoin isOpen={isOpen} {...props} />
}

export default Wrapper